var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.99,
    height: 27.99,
    rx: 8.75,
    fill: "#EAD6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9951 8.15625V19.8146",
    stroke: "#9810FA",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9092 9.90479H12.5373C11.9962 9.90479 11.4772 10.1197 11.0946 10.5023C10.712 10.885 10.4971 11.4039 10.4971 11.945C10.4971 12.4861 10.712 13.005 11.0946 13.3876C11.4772 13.7703 11.9962 13.9852 12.5373 13.9852H15.4519C15.993 13.9852 16.5119 14.2002 16.8945 14.5828C17.2771 14.9654 17.4921 15.4843 17.4921 16.0254C17.4921 16.5665 17.2771 17.0854 16.8945 17.4681C16.5119 17.8507 15.993 18.0656 15.4519 18.0656H10.4971",
    stroke: "#9810FA",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollars);
export default __webpack_public_path__ + "static/media/dollars.fafe8e8885e9962ee80f3b3a18ed7efe.svg";
export { ForwardRef as ReactComponent };